module.exports = __webpack_public_path__ + "img/card8.8b0fa80f.png";